import styled from 'styled-components'
import { StyledExternalLink } from '../../../theme/Global'

export const ShowMoreLink = styled(StyledExternalLink)`
  font-style: italic;
  font-size: 12px;
`

export const TruncateWrapper = styled.div`
  ${(props) => (props.truncate ? `
    max-height: 3rem;
    overflow: hidden;
    :after {
      display: inline-block;
      content: '...';
    }
  ` : `
    max-height: unset;
    overflow: unset;
  `)};
`
